import { useEffect } from 'react'
import { useVODStore } from '@/shared/store'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { selectVodRowItems } from '@/shared/store/storeSelectors/vodSelectors'
import VodItem from '@/features/VOD/vodClasses/vodItem'

export const useItemFetcher = (
    id: number | string,
    setRowItems: (items: VodItem[]) => VodItem[],
    getItems: () => Promise<VodItem[]>,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    url?: string
) => {
    const vodRowItems = useVODStore(selectVodRowItems)
    const { createId } = useVODService()

    useEffect(() => {
        const responseId = createId(id)
        const rowItemsToDisplay = vodRowItems.find(
            (item) => item.rowId === responseId
        )

        const handleFetchData = async () => {
            const response = await getItems()

            if (response.length) {
                return
            } else if (rowItemsToDisplay) {
                setRowItems(rowItemsToDisplay.content)
            }
        }

        handleFetchData()
    }, [id])
}
